import request from "@/utils/request";

export function getTadrisInfo() {
  return request({
    url: "tadris/data",
    method: "post",
  });
}

export function getTadrisDoreh() {
  return request({
    url: "tadris/getdoreh",
    method: "post",
  });
}

export function getDorehSchool(SrlLearnningGroup) {
  
  return request({
    url: "tadris/getschool",
    method: "post",
    data: { SrlLearnningGroup: SrlLearnningGroup },
  });
}

export function saveRequest(doreh, schoolArray, comment) {
  return request({
    url: "tadris/save",
    method: "post",
    data: { SrlSchoolArray: schoolArray, SrlCycle: doreh, Comment: comment },
  });
}

// export function downloadAttach(requestID, step) {
//   return request({
//     url: '/madrak/downloadattach',
//     method: 'post',

//     data: { RequestID: requestID,  Step: step }
//   })

// }
